export function isNullOrUndefined(value: unknown): boolean {
    return value === null || value === undefined;
}

export function isNotNullOrUndefined(value: unknown): boolean {
    return !isNullOrUndefined(value);
}
